"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonKindGridColumnKeys = void 0;
exports.nonKindGridColumnKeys = [
    "w",
    "mw",
    "align",
    "serverSideSortKey",
    "clientSideSort",
    "sticky",
    "wrapAction",
    "isAction",
    "id",
    "canHide",
    "initVisible",
    "expandColumns",
    "initExpanded",
];
